//https://labs.tadigital.com/index.php/2019/04/17/user-permissions-in-vue-js/

// const casl = require('casl');


// https://www.npmjs.com/package/@casl/ability

import { AbilityBuilder } from '@casl/ability'
// import { subject } from '@casl/ability'



// module.exports = function defineAbilities(user) {
//   return casl.AbilityBuilder.define(
//     { subjectName: item => item }, 
//     can => {
//       can(['read', 'create'], 'Post');
//       can(['update', 'delete'], 'Post', { user: user });
//     }
//   );
// };

// export const userRole = {teste: "feito"};

// export function defineAbilitiesFor(user) {
//   console.log("defineAbilitiesFor", user)
//   return AbilityBuilder.define((can, cannot) => {
//     if (user.isAdmin()) {
//       can('manage', 'all')
//     } else {
//       can('read', 'all')
//     }
//   })
// }

export default AbilityBuilder.define({ subjectName }, can => {
  // console.log('DENTRO DO ABILITY', subjectName);
  // can(['manage'], 'all')
  // can(['update', 'delete'], 'Todo', { assignee: 'me' })
});

// export function (type) {
//   AbilityBuilder.define(can => {
//     switch(type) {
//       case 'guest':
//         can('read', 'Post');
//         break;
//       case 'admin':
//         can('read', 'Post');
//         can(['update', 'delete'], 'Post');
//         break;
//     }
//   }
// };


/**
 * Defines how to detect object's type: https://stalniy.github.io/casl/abilities/2017/07/20/define-abilities.html
 */
function subjectName(item) {
  // console.log("Ability ITEM", item);
  if (!item || typeof item === 'string') {
    // console.log("Ability ITEM dentro do IF", item);
    return item
  }
  // console.log("Ability ITEM fora do IF", item.__type);
  return item.__type
}

// export default function defineAbilitiesFor(user) {
//   console.log("defineAbilitiesFor", user)
//   return AbilityBuilder.define((can, cannot) => {
//     if (user.role ==='admin') {
//       can('manage', 'all')
//     } else {
//       can('read', 'all')
//     }
//   })
// }


// export default AbilityBuilder.define(can => {
//   can('read', 'all')
// })

